import { render } from "./VacancyCard.vue?vue&type=template&id=1000dfc5&scoped=true"
import script from "./VacancyCard.vue?vue&type=script&lang=js"
export * from "./VacancyCard.vue?vue&type=script&lang=js"

import "../pages/public-job-vacancy.scss?vue&type=style&index=0&id=1000dfc5&lang=scss&scoped=true"

import exportComponent from "/var/www/hrms.automaxion.io/public_html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1000dfc5"]])

export default __exports__